import "./App.css";
import "./theme.css";
import { AppRouter } from "./components/AppRouter/AppRouter";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { ConfigProvider } from "./context/ConfigContext";
import { UserProvider } from "./context/UserContext";
import { FlowIDProvider } from "./context/FlowIDContext";
import { OpenCvProvider } from "opencv-react";
import { AmplitudeProvider } from "./context/AmplitudeContext";

function App() {
  return (
    <div className="App">
      <I18nextProvider i18n={i18n}>
        <OpenCvProvider openCvPath="/libs/opencv.js">
          <ConfigProvider>
            <UserProvider>
              <FlowIDProvider>
                <AmplitudeProvider>
                  <AppRouter />
                </AmplitudeProvider>
              </FlowIDProvider>
            </UserProvider>
          </ConfigProvider>
        </OpenCvProvider>
      </I18nextProvider>
    </div>
  );
}

export default App;
